export default __webpack_public_path__ + "static/media/highlightGreen.c5670704.svg";